export default "__VITE_ASSET__BZU_Cga6__"